import { render, staticRenderFns } from "./TableNumberForm.vue?vue&type=template&id=6d2f8890&scoped=true&"
import script from "./TableNumberForm.vue?vue&type=script&lang=js&"
export * from "./TableNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./TableNumberForm.vue?vue&type=style&index=0&id=6d2f8890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f8890",
  null
  
)

export default component.exports